import { motion } from "framer-motion";

const reveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: {
      duration: 1.1,
      delay: 0.6 + i * 0.08,
      ease: [0.22, 1, 0.36, 1],
    },
  }),
};

export default function HeroSection() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full flex flex-col"
    >
      {/* Top meta strip */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.4, delay: 1 }}
        className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24 pt-32 md:pt-40 flex items-start justify-between"
      >
        <div className="flex flex-col gap-1 max-w-xs">
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
            [ Index / 2026 ]
          </span>
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#8a8a8a]">
            Chennai → Earth
          </span>
        </div>
        <div className="hidden md:flex flex-col gap-1 text-right max-w-sm">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
            Open-source first
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
            Sovereign · Deployable · Real
          </span>
        </div>
      </motion.div>

      {/* Bottom content */}
      <div className="flex-1 flex flex-col justify-end pb-16 md:pb-24">
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24">
          {/* Positioning line */}
          <div className="overflow-hidden mb-6 md:mb-10">
            <motion.p
              custom={0}
              variants={reveal}
              initial="hidden"
              animate="show"
              className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] text-[#8a8a8a]"
              data-testid="hero-tagline"
            >
              <span className="text-[#d4ff00]">●</span>&nbsp;&nbsp;Applied AI
              Research &amp; Engineering Lab
            </motion.p>
          </div>

          {/* Big title */}
          <h1
            className="font-display tracking-tightest leading-[0.85] uppercase font-medium text-[#fafafa]"
            style={{ fontSize: "clamp(3rem, 12vw, 13rem)" }}
            data-testid="hero-title"
          >
            <span className="block overflow-hidden">
              <motion.span
                custom={1}
                variants={reveal}
                initial="hidden"
                animate="show"
                className="block"
              >
                Ziraminds
              </motion.span>
            </span>
            <span className="block overflow-hidden">
              <motion.span
                custom={2}
                variants={reveal}
                initial="hidden"
                animate="show"
                className="block"
              >
                <span className="text-[#4a4a4a]">/&nbsp;</span>AI
              </motion.span>
            </span>
          </h1>

          {/* Sub line */}
          <div className="mt-10 md:mt-14 grid grid-cols-12 gap-6 items-end">
            <div className="col-span-12 md:col-span-5 md:col-start-7 overflow-hidden">
              <motion.p
                custom={3}
                variants={reveal}
                initial="hidden"
                animate="show"
                className="text-base md:text-lg text-[#8a8a8a] leading-relaxed font-light max-w-md"
              >
                We design, build &amp; deploy intelligent systems that{" "}
                <span className="text-white">generate</span>,{" "}
                <span className="text-white">understand</span> and{" "}
                <span className="text-white">act</span> on knowledge — in the
                real world.
              </motion.p>
            </div>
          </div>

          {/* Bottom strip */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.4 }}
            className="mt-14 md:mt-20 flex items-end justify-between border-t border-white/10 pt-5"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#d4ff00]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#fafafa]">
                Scroll &nbsp;/&nbsp; Begin Transmission
              </span>
            </div>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
              v 0.1 — Phase 01
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
